import { render, staticRenderFns } from "./Seal.vue?vue&type=template&id=4c1890e5&scoped=true"
import script from "./Seal.vue?vue&type=script&lang=js"
export * from "./Seal.vue?vue&type=script&lang=js"
import style0 from "./Seal.vue?vue&type=style&index=0&id=4c1890e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1890e5",
  null
  
)

export default component.exports